import pipe1 from "../../assets/images/products/pro-01.jpg";
import pipe2 from "../../assets/images/products/pro-02.jpg";
import pipe3 from "../../assets/images/products/pro-03.jpg";
import pipe4 from "../../assets/images/products/pro-04.jpg";
import pipe5 from "../../assets/images/products/pro-05.jpg";
import pipe6 from "../../assets/images/products/pro-06.jpg";
import pipe7 from "../../assets/images/products/pro-07.jpg";
import pipe8 from "../../assets/images/products/pro-08.jpg";
import pipe9 from "../../assets/images/products/pro-09.jpg";
import pipe10 from "../../assets/images/products/pro-10.jpg";
import pipe11 from "../../assets/images/products/pro-11.jpg";
import pipe12 from "../../assets/images/products/pro-12.jpg";
import pipe13 from "../../assets/images/products/pro-13.jpg";
import pipe14 from "../../assets/images/products/pro-14.jpg";
import pipe15 from "../../assets/images/products/pro-15.jpg";

const productData = [
  {
    class: "Class NP1 (Light Duty Pipe)",
    image: pipe1,
    size: "150mm - 600mm",
    price: "₹900 - ₹4,500 / meter",
    rating: 4,
  },
  {
    class: "Class NP2 (Non-Pressure Pipe)",
    image: pipe2,

    size: "150mm - 1200mm",
    price: "₹1,200 - ₹8,500 / meter",
    rating: 4,
  },
  {
    class: "Class NP3 (Medium Heavy Pipe)",
    image: pipe3,

    size: "300mm - 1800mm",
    price: "₹2,400 - ₹18,000 / meter",
    rating: 5,
  },
  {
    class: "Class NP4 (Heavy Structural Pipe)",
    image: pipe4,

    size: "450mm - 2400mm",
    price: "₹4,200 - ₹32,500 / meter",
    rating: 5,
  },
  {
    class: "Class P1 (Low Pressure Pipe)",
    image: pipe5,

    size: "200mm - 1000mm",
    price: "₹1,800 - ₹12,000 / meter",
    rating: 4,
  },
  {
    class: "Class P2 (Medium Pressure Pipe)",
    image: pipe6,

    size: "250mm - 1500mm",
    price: "₹3,100 - ₹22,000 / meter",
    rating: 5,
  },
  {
    class: "Class P3 (High Pressure Pipe)",
    image: pipe7,

    size: "300mm - 1800mm",
    price: "₹4,000 - ₹28,000 / meter",
    rating: 5,
  },
  {
    class: "RCC Jacking Pipe",
    image: pipe8,

    size: "600mm - 2000mm",
    price: "₹7,500 - ₹40,000 / meter",
    rating: 5,
  },
  {
    class: "RCC Culvert Pipe",
    image: pipe9,

    size: "600mm - 1800mm",
    price: "₹5,500 - ₹26,000 / meter",
    rating: 4,
  },
  {
    class: "Reinforced Drainage Pipe",
    image: pipe10,

    size: "300mm - 1500mm",
    price: "₹2,800 - ₹20,000 / meter",
    rating: 4,
  },
  {
    class: "Storm Water RCC Pipe",
    image: pipe11,

    size: "600mm - 2400mm",
    price: "₹6,000 - ₹38,000 / meter",
    rating: 5,
  },
  {
    class: "Industrial Sewer Pipe",
    image: pipe12,

    size: "450mm - 1800mm",
    price: "₹5,000 - ₹30,000 / meter",
    rating: 5,
  },
  {
    class: "Road Crossing RCC Pipe",
    image: pipe13,

    size: "600mm - 2000mm",
    price: "₹6,500 - ₹35,000 / meter",
    rating: 5,
  },
  {
    class: "Irrigation RCC Pipe",
    image: pipe14,

    size: "300mm - 1500mm",
    price: "₹2,500 - ₹19,000 / meter",
    rating: 4,
  },
  {
    class: "Heavy Duty RCC Hume Pipe",
    image: pipe15,

    size: "900mm - 3000mm",
    price: "₹8,000 - ₹55,000 / meter",
    rating: 5,
  },
];

export default productData;
